import { ModelApiService } from './BaseApiService'

/** CRUD operations for Sub Bubble Agreements
 * To retrieve Sub Bubble Agreements for a Client or Client Group, please reference ClientAPIService & ClientGroupAPIService
 */
export default class SubBubbleAgreementsApiService extends ModelApiService {
  constructor() {
    super('sub-bubble-agreement')
  }
}
